<template>

<svg 
	 xmlns="http://www.w3.org/2000/svg"   
	 viewBox="-11.5 780.5 24 24" >
<path d="M0.5,782.5l3.81,3.81l-3.81,3.81l-3.81-3.81L0.5,782.5z M8.12,790.12v6.67c-2.86,0.95-4.76,0-7.62,2.86
	c-2.86-2.86-4.76-1.91-7.62-2.86v-6.67c2.86,0.95,4.77,0.02,7.62,2.86C3.36,790.12,5.26,791.07,8.12,790.12L8.12,790.12z
	 M10.02,792.02v7.62l-7.62,1.9v0.95H-1.4v-0.95l-7.62-1.9v-7.62l0.95,0.24v6.43l7.62,1.9v0.71l0.95,0.24l0.95-0.24v-0.71l7.62-1.9
	v-6.43L10.02,792.02z"/>
</svg>

</template>